import { render, staticRenderFns } from "./index.vue?vue&type=template&id=dc17eac0"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/prod2/jobs/build/partner-assets-build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dc17eac0')) {
      api.createRecord('dc17eac0', component.options)
    } else {
      api.reload('dc17eac0', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=dc17eac0", function () {
      api.rerender('dc17eac0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vab/components/VabCheckboxGroup/index.vue"
export default component.exports